export default __webpack_public_path__ + "static/media/es.c2bea6d7.svg";